import { Geolocation } from '@capacitor/geolocation'
import { point, featureCollection } from '@turf/turf'

type Coordinates = {
  latitude: number
  longitude: number
}

export const getDeviceLocationPermission = async (permission?: string) => {
  if (permission == 'granted' || permission === 'denied') return permission
  try {
    const status = await Geolocation.requestPermissions()
    const permission = status.location || status.coarseLocation
    return getDeviceLocationPermission(permission)
  } catch (error) {
    return 'denied'
  }
}

export const getDevicePosition = async () => {
  try {
    const {
      coords: { latitude, longitude }
    } = await Geolocation.getCurrentPosition()
    return { latitude, longitude }
  } catch (error) {
    return null
  }
}

export const getMapUrl = (coordinates: Coordinates) => `http://maps.google.com/maps?q=${coordinates.latitude},${coordinates.longitude}`

export const coordinatesToString = (coordinates: Coordinates, precision: number) =>
  coordinates ? `${coordinates.latitude.toFixed(precision)}, ${coordinates.longitude.toFixed(precision)}` : null

export const coordinatesToFeatures = (coordinates: Coordinates[], labels: string[]) => {
  const features = coordinates.map((val, index) => point([val.longitude, val.latitude], { name: labels[index] || '' }))
  return featureCollection(features)
}

export const getPermissionStatus = async () => {
  try {
    const status = await Geolocation.checkPermissions()
    const permission = status.location || status.coarseLocation
    return permission
  } catch (error) {
    return null
  }
}

export const requestPermission = async () => {
  try {
    await Geolocation.requestPermissions()
  } catch (error) {
    return null
  }
}
